import React, {useCallback, useEffect, useMemo, useState} from "react";
import {
  Col,
  Row,
  Button,
  Input,
  Table,
  DatePicker,
  Select,
  Modal,
  Avatar, Popconfirm, Tooltip, Card,
} from "antd";
import {
  DatabaseOutlined,
  DeleteOutlined,
  EyeOutlined, FileTextOutlined,
  SearchOutlined, ThunderboltOutlined,
  UserOutlined,
  RobotOutlined,
DollarOutlined,
  FileWordOutlined,
MessageOutlined
} from "@ant-design/icons";
import constants from "../utils/constants";
import "../openAi/OpenAi.scss";
import MarkdownViewer from "../utils/MarkdownViewer"
import {showNotification} from "../utils/commonFunctions";
import moment from "moment-timezone";
import { Pie, Doughnut } from "react-chartjs-2";

const { REACT_APP_API_ENDPOINT } = process.env;
const BASE_URL = REACT_APP_API_ENDPOINT;
const PAGE_SIZE = 10;

const AiChatConversations = () => {
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [list, setList] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [selectedConversation, setSelectedConversation] = useState([]);
  const [dashboardHistoryData, setDashboardHistoryData] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  // const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [models, setModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);
  const [usersPagination, setUsersPagination] = useState({
    page: 1,
    hasMore: true,
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
    total: 0,
  });

  const fetchHistoryData = useCallback(
    async (
      text = "",
      // page = 1,
      // pageSize = PAGE_SIZE,
      start = null,
      end = null,
      model = null,
      selectedUser = null
    ) => {
      try {
        setLoading(true);
        const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);
        let apiUrl = `${"https://chatbot.writely.io"}/api/v1/history/dashboard`;
        const params = [];
        if (text) params.push(`text=${encodeURIComponent(text)}`);
        if (start) params.push(`start_date=${start}`);
        if (end) params.push(`end_date=${end}`);
        if (model) params.push(`model=${encodeURIComponent(model)}`);
        if (selectedUser) params.push(`created_by=${selectedUser}`);
        // params.push(`page=${page}`);
        // params.push(`limit=${pageSize}`);
        if (params.length) apiUrl += `?${params.join("&")}`;

        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();
        console.log("------>",result)
        if (result.meta.success && result.data) {
          setDashboardHistoryData(result?.data)
          setList(result?.data?.userSummary || []);
          // setPagination({
          //   current: page,
          //   pageSize,
          //   total: result.data?.totalRecords || result.data.length || 0,
          // });
        } else {
          setList([]);
          // setPagination({ current: 1, pageSize, total: 0 });
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        setList([]);
        // setPagination({ current: 1, pageSize, total: 0 });
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL]
  );

  const fetchModels = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);
      const response = await fetch(`${BASE_URL}/api/v1/openAi/model-list`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (result.success && result.data) {
        setModels(result.data);
      }
    } catch (error) {
      console.error('Error fetching models:', error);
    }
  }, [BASE_URL]);

  // const fetchUsers = useCallback(
  //   async (page = 1, reset = false) => {
  //     try {
  //       setUsersLoading(true);
  //       const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);
  //       const response = await fetch(
  //         `${BASE_URL}/api/v1/users?page=${page}&limit=100`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //
  //       const result = await response.json();
  //       if (result.meta.success && result.data) {
  //         const newUsers = result.data;
  //         setUsers((prev) => (reset ? newUsers : [...prev, ...newUsers]));
  //         setUsersPagination({
  //           page,
  //           hasMore:
  //             newUsers.length === 10 && result.meta.totalCount > page * 10,
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching users:", error);
  //     } finally {
  //       setUsersLoading(false);
  //     }
  //   },
  //   [BASE_URL]
  // );

  const deleteHistory = useCallback(
      async (id) => {
        try {
          setUsersLoading(true);
          const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);
          const response = await fetch(
              `${BASE_URL}/api/v1/history/${id}`,
              {
                method: "DELETE",
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                  "Content-Type": "application/json",
                },
              }
          );

          const result = await response.json();
          if (result.meta.success) {
            let deleteItem = list.filter(o=>o._id !== id);
            setList(deleteItem)
          }
          setUsersLoading(false)
        } catch (error) {
          console.error("Error fetching users:", error);
        } finally {
          setUsersLoading(false);
        }
      },
      [BASE_URL]
  );

  const handleViewClick = useCallback((record) => {
    setModalVisible(true);
    setSelectedConversation(record);
  }, [selectedConversation]);

  const handleModelChange = useCallback((value) => {
    setSelectedModel(value);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
  }, []);

  const handleSubmit = useCallback(() => {
    const startDateStr = startDate ? startDate.format("YYYY-MM-DD") : null;
    const endDateStr = endDate ? endDate.format("YYYY-MM-DD") : null;
    fetchHistoryData(
      searchName,
      // 1,
      // PAGE_SIZE,
      startDateStr,
      endDateStr,
      selectedModel,
      selectedUserId
    );
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [fetchHistoryData, searchName, startDate, endDate, selectedUserId, selectedModel]);

  const handleResetSearch = useCallback(() => {
    setSearchName("");
    setStartDate(null);
    setEndDate(null);
    setSelectedUserId(null);
    setSelectedModel(null);
    fetchHistoryData("", null, null, null, null);
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [fetchHistoryData]);
  const data = {
    labels: dashboardHistoryData?.overallModelSplit?.map(o=>o.model?.split(" - ")[1]) || [],
    datasets: [
      {
        label: "Total usage in %: ",
        data: dashboardHistoryData?.overallModelSplit?.map(o=>Number(o.percentage?.toFixed(0))) || [],
        backgroundColor: [
          "rgba(54, 162, 235, 0.7)",   // Blue
          "rgba(255, 99, 132, 0.7)",   // Rose Red
          "rgba(255, 206, 86, 0.7)",   // Yellow
          "rgba(75, 192, 192, 0.7)",   // Teal
          "rgba(255, 159, 64, 0.7)",   // Orange
          "rgba(153, 102, 255, 0.7)",  // Purple
          "rgba(255, 87, 34, 0.7)",    // Deep Orange
          "rgba(0, 200, 83, 0.7)",     // Green
          "rgba(0, 123, 255, 0.7)"     // Vibrant Blue
        ],
        borderColor: [
          "rgba(54, 162, 235, 1)",   // Blue border
          "rgba(255, 99, 132, 1)",   // Rose Red border
          "rgba(255, 206, 86, 1)",   // Yellow border
          "rgba(75, 192, 192, 1)",   // Teal border
          "rgba(255, 159, 64, 1)",   // Orange border
          "rgba(153, 102, 255, 1)",  // Purple border
          "rgba(255, 87, 34, 1)",    // Deep Orange border
          "rgba(0, 200, 83, 1)",     // Green border
          "rgba(0, 123, 255, 1)"     // Vibrant Blue border
        ],
        borderWidth: 2,
      },
    ],
  };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: "right",
      },
    };


  useEffect(() => {
    fetchHistoryData("", null, null, null, null);
    fetchModels();
  }, [fetchHistoryData, fetchModels]);

  // Table Columns with Serial Number
  const columns = [
    {
      title: "S.No",
      key: "index",
      width: "5%",
      render: (_, __, index) => {
        return (
          <span
            style={{
              minHeight: "40px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {(pagination.current - 1) * pagination.pageSize + index + 1}
          </span>
        );
      },
    },
    {
      title: "User",
      dataIndex: "created_by",
      key: "first_name",
      width: "25%",
      render: (_, record) => (
        <div style={{display:"flex", flexDirection:"column"}}>
          <label>{record?.first_name + " " +  (record?.last_name || "")}</label>
          <p>{record?.email}</p>
        </div>

      )
    },
    {
      title: "Tokens",
      dataIndex: "totalToken",
      key: "totalToken",
      width: "10%",
      render: (_, record) => record?.totalTokens || 0,
    },
    {
      title: "Cost",
      dataIndex: "totalCost",
      key: "totalCost",
      width: "10%",
      render: (_, record) => "$"+record?.totalCost?.toFixed(4) || 0,
    },
    {
      title: "Word Count",
      dataIndex: "totalWords",
      key: "totalWords",
      width: "10%",
      render: (_, record) => +record?.totalWords || 0,
    },
    {
      title: "Last Used",
      dataIndex: "created_at",
      key: "created_at",
      width: "10%",
      render: (_, record) => {
        const date = new Date(record?.lastUsage);
        return date.toLocaleDateString("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      },
    },
    {
      title: "Last Used Model",
      dataIndex: "highestUsedModel",
      key: "highestUsedModel",
      width: "20%",
      render: (_, record) => record?.highestUsedModel,
    },
    // {
    //   title: "Conversations",
    //   dataIndex: "totalChats",
    //   key: "totalChats",
    //   render: (_, record) => record?.totalChats,
    // },
    {
      title: "Action",
      key: "conversation",
      width: "10%",
      render: (_, record) => {
        return (
          <>
            <EyeOutlined
              style={{ cursor: "pointer", marginRight: "15px" }}
              onClick={() => handleViewClick(record)}
            />
            <Tooltip title="Delete">
              <Popconfirm
                  title="Are you sure to delete this?"
                  onConfirm={() => showNotification("error", "Delete functionality is under maintenance.")}
                  okText="Yes"
                  cancelText="No"
                  placement="bottom"
                  disabled={usersLoading}
              >
                <DeleteOutlined
                    style={{
                      fontSize: "16px",
                      cursor: "pointer",
                      margin: " 0 20px",
                    }}
                />
              </Popconfirm>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const counters = useMemo(() => {
    if (!dashboardHistoryData) {
      return [
        { label: "Total Conversations", value: "0", icon: <MessageOutlined style={{ fontSize: "24px", color: "#f5222d" }} /> },
        { label: "Total Users", value: "0", icon: <UserOutlined style={{ fontSize: "24px", color: "#1890ff" }} /> },
        { label: "Total Models", value: "0", icon: <RobotOutlined style={{ fontSize: "24px", color: "#52c41a" }} /> },
        { label: "Usage Tokens", value: "0", icon: <ThunderboltOutlined style={{ fontSize: "24px", color: "#faad14" }} /> },
        { label: "Total Words Count", value: "0", icon: <FileTextOutlined style={{ fontSize: "24px", color: "#2b2b2f" }} /> },
        { label: "Total Usage Cost", value: "0", icon: <DollarOutlined style={{ fontSize: "24px", color: "#f5222d" }} /> },
      ];
    }
    const totalTokens = (dashboardHistoryData?.totalTokens / 1000) || 0;
    const totalRecords = dashboardHistoryData?.totalConversations || 0;
    const totalModels =  dashboardHistoryData?.totalModels || 0;
    const totalUsers = dashboardHistoryData?.totalUsers || 0;
    const totalCosts = dashboardHistoryData?.grandTotalCost || 0;
    const totalWords = (dashboardHistoryData?.totalWords/1000) || 0;
    return [
      { label: "Total Conversations", value: totalRecords.toString(), icon: <MessageOutlined style={{ fontSize: "24px", color: "#f5222d" }} /> },
      { label: "Total Users Count", value: totalUsers.toString(), icon: <UserOutlined style={{ fontSize: "24px", color: "#1890ff" }} /> },
      { label: "Total Models Count", value: totalModels.toString(), icon: <RobotOutlined style={{ fontSize: "24px", color: "#52c41a" }} /> },
      { label: "Usage Tokens Count", value: totalTokens.toFixed(0)+"K", icon: <ThunderboltOutlined style={{ fontSize: "24px", color: "#faad14" }} /> },
      { label: "Total Words Count", value: totalWords.toFixed(0)+"K", icon: <FileTextOutlined style={{ fontSize: "24px", color: "#2b2b2f" }} /> },
      { label: "Total Usage Cost", value: totalCosts.toLocaleString(), icon: <DollarOutlined style={{ fontSize: "24px", color: "#f5222d" }} /> },
    ];
  }, [dashboardHistoryData]);

  const handleTableChange = (pagination) => {
    // const startDateStr = startDate ? startDate.format('YYYY-MM-DD') : null;
    // const endDateStr = endDate ? endDate.format('YYYY-MM-DD') : null;
    // fetchDashboardData(searchEmail, pagination.current, pagination.pageSize, startDateStr, endDateStr, selectedModel, selectedUserId);
    setPagination(pagination);
  };

  return (
    <Col style={{ padding: "24px" }} className="content-body">
      <Row style={{justifyContent:"space-between", marginBottom: "20px"}}>
        <div style={{width: "50%"}}>
          <Row gutter={[20, 20]}>
            {counters.map((counter, i) => (
                <Col
                    key={i}
                    xs={24}
                    sm={8}
                    md={8}
                    lg={8}
                >
                  <Card
                      style={{
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        borderRadius: "8px",
                      }}
                  >
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      height: "60px"
                    }}>
                      <div style={{ flex: 1 }}>
                        <div style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          marginBottom: "4px",
                          color: "#262626"
                        }}>
                          {counter.label === "Total Usage Cost" ? "$" +counter.value : counter.value}
                        </div>
                        <div style={{
                          fontSize: "14px",
                          color: "#8c8c8c",
                          fontWeight: "400"
                        }}>
                          {counter.label}
                        </div>
                      </div>
                      <div style={{ marginLeft: "16px" }}>
                        {counter.icon}
                      </div>
                    </div>
                  </Card>
                </Col>
            ))}
          </Row>

                </div>
        <div style={{width: "50%"}}>
          <Pie data={data} options={options} />
        </div>
      </Row>

      {/* Search Section */}
      <Row gutter={[10, 10]} style={{ marginBottom: "20px" }}>
        <Col xs={24} sm={24} md={7} lg={5} xl={4}>
          <Input
            placeholder="Search by Name"
            prefix={<SearchOutlined />}
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            allowClear
            size="large"
          />
        </Col>
        <Col xs={24} sm={12} md={5} lg={4} xl={3}>
          <DatePicker
            placeholder="Start Date"
            value={startDate}
            onChange={setStartDate}
            size="large"
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
          />
        </Col>
        <Col xs={24} sm={12} md={5} lg={4} xl={3}>
          <DatePicker
            placeholder="End Date"
            value={endDate}
            onChange={setEndDate}
            size="large"
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
          />
        </Col>
        <Col xs={24} sm={12} md={4} lg={3} xl={3} xxl={3}>
          <Select
              placeholder="Select Model"
              value={selectedModel}
              onChange={handleModelChange}
              size="large"
              style={{ width: "100%" }}
              allowClear
              showSearch
              filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={models.map(model => ({
                value: model.id,
                label: model.id
              }))}
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={5} xl={4}>
          <Select
            placeholder="Select User"
            value={selectedUserId}
            onChange={setSelectedUserId}
            size="large"
            allowClear
            showSearch
            loading={usersLoading}
            options={dashboardHistoryData?.userList?.map((user) => ({
              value: user._id,
              label: `${user.first_name} (${user.email})`,
            }))}
            notFoundContent={usersLoading ? "Loading..." : "No users found"}
            style={{ width: "100%" }}
          />
        </Col>
        <Col xs={12} sm={12} md={6} lg={3} xl={2}>
          <Button
            type="primary"
            size="large"
            onClick={handleSubmit}
            loading={loading}
            style={{ width: "100%" }}
          >
            Submit
          </Button>
        </Col>
        <Col xs={12} sm={12} md={6} lg={3} xl={2}>
          <Button
            size="large"
            onClick={handleResetSearch}
            style={{ width: "100%" }}
          >
            Reset
          </Button>
        </Col>
      </Row>

      {/* Table Section */}
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={list}
            rowKey={(record) => record._id}
            loading={loading}
            pagination={{
              ...pagination,
              showSizeChanger: false,
              pageSize: PAGE_SIZE,
            }}
            onChange={handleTableChange}
            locale={{
              emptyText: loading ? "Loading..." : "No data available",
            }}
          />
        </Col>
      </Row>

      {/* View Details Modal */}
      <Modal
          title={
            <span style={{ color: "black", fontSize: "20px" }}>
      {"Conversation Details - " + (selectedConversation?.first_name || "")}
    </span>
          }
          open={modalVisible}
          onCancel={handleModalClose}
          width={800}
          footer={[
            <Button key="close" onClick={handleModalClose}>
              Close
            </Button>,
          ]}
          bodyStyle={{
            maxHeight: "400px",     // 👈 scrolling area height
            overflowY: "auto",      // 👈 enables scroll
            paddingRight: "10px",
          }}
          styles={{
            footer: {
              position: "sticky",
              bottom: 0,
              background: "#fff",
              zIndex: 10,
              borderTop: "1px solid #f0f0f0",
            }
          }}
      >
        <div style={{ whiteSpace: "pre-wrap" }}>
            {
              selectedConversation && selectedConversation?.conversations?.length > 0 && selectedConversation?.conversations?.map((message) => {
                return (
                    <div className="chat-container">
                      {
                          message.role === "user" ? (<div className="chat-c-query">
                            <Avatar
                                style={{
                                  backgroundColor: "#f3f3f3",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginTop: "5px",
                                }}
                                icon={
                                  <UserOutlined style={{ fontSize: "14px", color: "#000" }} />
                                }
                            /><div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                            <label style={{fontSize: "12px", color: "grey"}}>{message?.model}</label>
                              <div className="chat-query">
                                <MarkdownViewer markdownContent={message?.message || ""}/>
                              </div>
                              <label style={{fontSize: "12px", color: "grey"}}>{moment(message?.timestamp).format("DD-MMM-YYYY - hh:mm A")}</label>
                          </div>
                          </div>) : (
                              <div className="chat-a-cb">
                            <div className="chat-ans">
                              <MarkdownViewer markdownContent={message.message}/>
                            </div>
                          </div>)
                      }
                    </div>
                )

                })
            }
        </div>
      </Modal>
    </Col>
  );
};

export default AiChatConversations;
